import { getEnv } from './env'
import { stringifyQueryString, navigateParentWindow } from './navigation'
import { bundleBuilderRedirectUrls } from '../constants/navigation'

export function redirectOnError(url, queryStrings = {}) {
  const { HOST_ENV } = getEnv()
  const qs = stringifyQueryString(queryStrings)

  if (HOST_ENV !== 'local') {
    navigateParentWindow(`${url}?${qs}`)
  }
}

export function handleRedirectError(error, opportunityId) {
  const { redirectURL, ...data } = error.data || {}

  if (redirectURL) {
    redirectOnError(redirectURL, {
      ...data,
      id: opportunityId
    })
  }
}

// Returns error message/redirect URL for API error if found
export function getApiErrorMessage({ response = {} } = {}) {
  const { messages = [] } = response.data || {}

  return messages.reduce((error, msg, index) => {
    // only return the first message
    if (index === 0) {
      return msg
    }

    // add redirectUrl if it exists
    if (msg.redirectUrl) {
      return {
        ...error,
        redirectUrl: msg.redirectUrl
      }
    }

    return error
  }, null)
}

export function createRedirectError(rawError, sourceSystem) {
  const errorMsg = getApiErrorMessage(rawError) || {}
  const error = new Error()

  // The below block is currently restricted to salesforce and will need to be resolutioned for orionsales
  // Hence, orionsales launched opps will continue to legacy flow rather than being redirected to bundle builder
  if (!errorMsg.redirectUrl && sourceSystem === 'salesforce') {
    const { HOST_ENV } = getEnv()
    errorMsg.redirectUrl = bundleBuilderRedirectUrls[HOST_ENV]
    // Regular expression to remove trailing query parameters i.e. ?id= 
    errorMsg.redirectUrl = errorMsg.redirectUrl.replace(/\?.*$/, '')
  }

  error.data = {
    redirectURL: errorMsg.redirectUrl,
    error: errorMsg.description || 'An error occurred',
    errorCode: errorMsg.code || rawError?.response?.status || 500,
    scontrolCaching: 1,
    statusCode: rawError?.response?.status,
    errorCodes: rawError?.response?.data?.errors
  }
  return error
}
